(() => {
  const jump = (hash, smooth) => {
    let target;
    try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch { return; }
    if (!target) return;
    document.querySelectorAll('.top-mobile-nav[open]').forEach(menu => { menu.open = false; });
    target.scrollIntoView({ block: 'start', behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
    const heading = target.querySelector('h1, h2, h3') || target;
    if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
    heading.focus({ preventScroll: true });
  };
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return;
    let target;
    try { target = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch { return; }
    if (!target) return;
    event.preventDefault();
    if (location.hash !== url.hash) history.pushState(null, '', url.hash);
    jump(url.hash, true);
  });
  window.addEventListener('hashchange', () => jump(location.hash, false));
  const initialJump = () => { if (location.hash) requestAnimationFrame(() => jump(location.hash, false)); };
  if (document.readyState === 'complete') initialJump();
  else window.addEventListener('load', initialJump, { once: true });
})();
